import { RootState } from '@app/redux/store';
import { ServiceEcommerce2, ECommerceProduct } from '@app/services/ServiceEcommerce';
import { Order } from '@entities/Order/module/types/orderType';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleResponse, MyAxios } from '@services/SettingAxios';
import { OrderSchema } from '../types/fastOrderSchema';
import { OneClickOrderDto } from './api.dto';
import { formatPhoneToApi } from '@app/shared/helpers/formedPhone';

const sendingOrderStatistics = async (orderId, items: ECommerceProduct[], extra: any) => {
  try {
    ServiceEcommerce2.purchase1Click({
      transaction_id: orderId,
      items,
    });
  } catch (error) {}
};

export type TypeError = {
  errorCode: number;
  errorMessage: string;
  redirect: string;
  success: boolean;
};

export const fetchOrderOneClick = createAsyncThunk<OrderSchema, OneClickOrderDto, { rejectValue: { data: TypeError; status: number } }>(
  'fastOrder/fetchOrderOneClick',
  async (query, thunkAPI) => {
    try {
      const orderData = await MyAxios.post<Order>('/api/order/1click', {
        ...query,
        phone: formatPhoneToApi(query.phone),
      })
        .then(handleResponse)
        .then((response: Order) => {
          let shop;
          if (response.order.SHOP_ID) {
            shop = response.order.SHOP_ID
              ? (thunkAPI.getState() as RootState).fastOrder.historyShops.find(shop => shop.shopId === response.order.SHOP_ID)
              : undefined;
            shop = {
              ...shop,
              url: response.order.shop.CODE,
              timeWork: response.order.shop.TIMEWORK,
            };
          }
          const products = response.order.parts.map(item => {
            return {
              title: item.NAME,
              quantity: item.QUANTITY,
              price: item.PRICE,
              id: item?.PRODUCT_ID,
              part: item?.PART,
              rn: item?.product?.rn || null,
            };
          });

          sendingOrderStatistics(response.id, products, {
            email: query.email,
            phone: query.phone,
            consent: Boolean(query.pddConsent),
            subscription: Boolean(query.subscriptionConsent),
          });

          return {
            shop,
            id: response.id,
            hash: response.hash,
            orderNumber: response.order.BILL_NUMB,
            totalSum: response.order.SUMM,
            products,
          };
        });

      return orderData;
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error.response.data, status: error.response.status });
    }
  },
);
